import {
  ApiResponse,
  InitOverrideFunction,
  SummaryApi,
  SummaryCancelSummarizationPostRequest,
  SummarySummarizeTextFilePostRequest,
} from "../../../@api";

export class SummaryApiService
  implements Omit<SummaryApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: SummaryApi) {}

  public summarySummarizeTextFilePost(
    requestParameters?: SummarySummarizeTextFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.summarySummarizeTextFilePost(requestParameters, initOverrides);
  }

  public summarySummarizeTextFilePostRaw(
    requestParameters: SummarySummarizeTextFilePostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<ApiResponse<string>> {
    return this.api.summarySummarizeTextFilePostRaw(requestParameters, initOverrides);
  }

  public summaryCancelSummarizationPost(
    requestParameters?: SummaryCancelSummarizationPostRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<string> {
    return this.api.summaryCancelSummarizationPost(requestParameters, initOverrides);
  }
}
